module.exports = __webpack_public_path__ + "d95d78806c750a063d0896a5fe18ef97.png";